import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import presentationService from "../services/presentation";
import { normalizePresentation, getSlidesCount } from "../utils/normalizePresentation";

const initialState = {
  presentations: []
}

export const getPresentation = createAsyncThunk(
  "presentation/get",
  async () => {
    const res = await presentationService.getPresentations();
    return res.data;
  }
)

export const createPresentation = createAsyncThunk(
  "presentation/create",
  async (info) => {
    const res = await presentationService.createPresentation(info);
    return res.data;
  }
)

export const updatePresentation = createAsyncThunk(
  "presentation/update",
  async (info) => {
    const res = await presentationService.updatePresentation(info);
    return res.data;
  }
)

export const schedulePresentation = createAsyncThunk(
  "presentation/schedule",
  async (info) => {
    const res = await presentationService.schedulePresentation(info);
    return res.data;
  }
)

export const deletePresentation = createAsyncThunk(
  "presentation/delete",
  async (info) => {
    const {id} = info;
    const res = await presentationService.deletePresentation(info);
    return {
      id,
      success: res.data
    };
  }
)
export const generatePresentation = createAsyncThunk(
  "presentation/generate",
  async (info) => {
    const {id} = info;
    const res = await presentationService.generatePresentation(info);
    return {
      id,
      success: res.data
    };
  }
)

export const previewSlide = createAsyncThunk(
  "presentation/slide/preview",
  async (info) => {
    const res = await presentationService.previewSlide(info);
    return res.data;
  }
)

export const createSlide = createAsyncThunk(
  "presentation/slide/create",
  async (info) => {
    const {presentation} = info;
    const res = await presentationService.createSlide(info);
    return {
      presentation,
      data: res.data
    };
  }
)

export const updateSlideAxes = createAsyncThunk(
  "presentation/slide/updateAxes",
  async (info) => {
    const res = await presentationService.updateSlideAxes(info);
    return res.data;
  }
)

export const updateSlide = createAsyncThunk(
  "presentation/slide/update",
  async (info) => {
    const {presentation} = info;
    const res = await presentationService.updateSlide(info);
    return {
      presentation,
      data: res.data
    };
  }
)

export const deleteSlide = createAsyncThunk(
  "presentation/slide/delete", 
  async (info) => {
    const {id, index} = info;
    const res = await presentationService.deleteSlide(info);
    return {
      id,
      index,
      success: res.data
    };
  }
)


export const moveSlide = createAsyncThunk(
  "presentation/slide/move", 
  async (info) => {
    const {sourceId, sourceIndex, destinationId, destinationIndex} = info;
    const res = await presentationService.moveSlide(info);
    return {
      sourceId, 
      sourceIndex, 
      destinationId, 
      destinationIndex,
      success: res.data
    };
  }
)

export const saveWizardPresentation = createAsyncThunk(
  "presentation/saveWizard",
  async (info) => {
    const res = await presentationService.saveWizardPresentation(info);
    return res.data;
  }
)

export const getOnePresentation = createAsyncThunk(
  "presentation/getOne",
  async (id) => {
    const res = await presentationService.getOnePresentation(id);
    return res.data;
  }
)

export const updateWizardPresentation = createAsyncThunk(
  "presentation/updateWizard",
  async (info) => {
    const res = await presentationService.updateWizardPresentation(info);
    return res.data;
  }
)

export const duplicatePresentation = createAsyncThunk(
  "presentation/duplicate",
  async (info) => {
    const res = await presentationService.duplicatePresentation(info);
    return res.data;
  }
)

export const uploadTemplate = createAsyncThunk(
  "presentation/uploadTemplate",
  async ({ presentationId, file }) => {
    const res = await presentationService.uploadTemplate(presentationId, file);
    return res.data;
  }
)

export const regeneratePresentation = createAsyncThunk(
  "presentation/regenerate",
  async (id) => {
    const res = await presentationService.regeneratePresentation(id);
    return res.data;
  }
)

const presentationSlice = createSlice({
  name: "presentation",
  initialState,
  reducers: {
  },
  extraReducers: (builder) => {
    builder.addCase(getPresentation.fulfilled, (state, action) => {
      state.presentations = (action.payload || []).map(normalizePresentation);
    })
    builder.addCase(createPresentation.fulfilled, (state, action) => {
      const {id, title, template_id, template_path, slides} = action.payload;
      state.presentations.push({
        id,
        title,
        template_id,
        template_path,
        slides
      });
    })
    builder.addCase(updatePresentation.fulfilled, (state, action) => {
      const {id, title, template_id, template_path, slides} = action.payload;
      const newPresentation = state.presentations.map(presentation => {
        if(presentation.id === id)
          return {
            id,
            title,
            template_id,
            template_path,
            slides
          }
        return presentation;
      });
      state.presentations = newPresentation

    })
    builder.addCase(deletePresentation.fulfilled, (state, action) => {
      const {id, success} = action.payload;
      const updatedPres = state.presentations.filter(item => item.id !== id);
      if(success) state.presentations = updatedPres;
    })
    builder.addCase(generatePresentation.fulfilled, (state, action) => {
      
    })
    builder.addCase(schedulePresentation.fulfilled, (state, action) => {
      
    })
    builder.addCase(createSlide.fulfilled, (state, action) => {
      const {presentation, data: {title, template_id, template_path, slides}} = action.payload;
      let slideJson = JSON.parse(slides);
      const updatedPres = state.presentations.map(item => {
        if(item.id === presentation)
          return {
            id: presentation,
            title,
            template_id,
            template_path,
            slides: slideJson
          }
        else
          return item
      })
      state.presentations = updatedPres;
    })
    builder.addCase(updateSlide.fulfilled, (state, action) => {
      const {presentation, data: {title, template_id, template_path, slides}} = action.payload;
      let slideJson = JSON.parse(slides);
      const updatedPres = state.presentations.map(item => {
        if(item.id === presentation)
          return {
            id: presentation,
            title,
            template_id,
            template_path,
            slides: slideJson
          }
        else
          return item
      })
      state.presentations = updatedPres;
    })
    builder.addCase(moveSlide.fulfilled, (state, action) => {
      const {sourceId, sourceIndex, destinationId, destinationIndex, success} = action.payload
      console.log(action.payload)
      const source = {
        droppableId: sourceId,
        index: sourceIndex
      }
      const destination = {
        droppableId: destinationId,
        index: destinationIndex
      }
      if( success ) {
        const sourceIndex = state.presentations.findIndex(
          item => item.id === source.droppableId
        );
        const destinationIndex = state.presentations.findIndex(
          item => item.id === destination.droppableId
        );
        if(source.droppableId !== destination.droppableId){
          const dragCard = state.presentations[sourceIndex].slides[source.index]
          const newSourceItems = state.presentations[sourceIndex].slides.filter((item, index) => index !== source.index);
          let newDestinationItems = [];

          for(let i=0;i<destination.index;i++)
            newDestinationItems.push(state.presentations[destinationIndex].slides[i])
          newDestinationItems.push(dragCard)
          for(let i=destination.index;i<state.presentations[destinationIndex].slides.length;i++)
            newDestinationItems.push(state.presentations[destinationIndex].slides[i])

          const newPresentation = state.presentations.map(presentation => {
            if(presentation.id === source.droppableId)
              return {
                ...presentation,
                slides: newSourceItems
              }
            else if(presentation.id === destination.droppableId)
              return {
                ...presentation,
                slides: newDestinationItems
              }
            return presentation;
          })
          state.presentations = newPresentation;
        }
        else {
          let newItems = state.presentations[sourceIndex].slides;
          let temp = newItems[source.index];
          newItems[source.index] = newItems[destination.index];
          newItems[destination.index] = temp;
          const newPresentation = state.presentations.map(item => {
            if(item.id === sourceId)
              return {
                ...item,
                slides: newItems
              }
            return item;
          });

          state.presentations = newPresentation
        }
      }
    })
    builder.addCase(deleteSlide.fulfilled, (state, action) => {
      const {id, index, success} = action.payload;
      if(success) {
        const sourceIndex = state.presentations.findIndex(item => item.id === id);
        const newItems = state.presentations[sourceIndex].slides.filter((item, i) => i!==index);
        const newPresentations = state.presentations.map(item => {
          if(item.id === id)
            return {
              ...item,
              slides: newItems
            }
          return item;
        })

        state.presentations = newPresentations
      }
    })
    builder.addCase(saveWizardPresentation.fulfilled, (state, action) => {
      const { id, title, template_id, template_path, description, slides_count } = action.payload;
      state.presentations.push({
        id,
        title,
        template_id: template_id || null,
        template_path: template_path || null,
        slides: [],
        description: description || '',
        slides_count: slides_count || 0,
      });
    })
    builder.addCase(updateWizardPresentation.fulfilled, (state, action) => {
      const { id, title, description, slides_count } = action.payload;
      state.presentations = state.presentations.map(item => {
        if (item.id === id)
          return { ...item, title, description: description || '', slides_count: slides_count || 0 };
        return item;
      });
    })
    builder.addCase(duplicatePresentation.fulfilled, (state, action) => {
      state.presentations.push(normalizePresentation(action.payload));
    })
  }
});

const { reducer } = presentationSlice;

export default reducer;